"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectVehicleStepDefinition = void 0;
const WidgetFormStepBase_1 = require("../../../../Plugin/WidgetStep/WidgetFormStepBase");
const WidgetFormStepPluginDefinition_1 = require("../../../../Plugin/WidgetStep/WidgetFormStepPluginDefinition");
const SelectVehicleForm_1 = require("../../../../Plugin/FormHandler/SelectVehicleForm");
const StepEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/StepEvents");
const WidgetEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/WidgetEvents");
const RepositoryTypes_1 = require("../../../../Enum/RepositoryTypes");
const TemplateTypes_1 = require("../../../../Enum/TemplateTypes");
const StepTypes_1 = require("../../../../Enum/StepTypes");
const Valuation_1 = require("../../../../Model/Valuation");
const InchcapeSelectorEvents_1 = require("../../Enum/InchcapeSelectorEvents");
const configs_1 = require("../../../../configs/configs");
class SelectVehicleStep extends WidgetFormStepBase_1.default {
    constructor(definition, widgetConfig, state, eventContext, ractiveWrapper, formHandlerProvider, returnLinkService, repoFactory, rmbHelper) {
        super(definition, widgetConfig, state, eventContext, ractiveWrapper, formHandlerProvider);
        this.widgetConfig = widgetConfig;
        this.valuationRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.VALUATION, { config: this.widgetConfig });
        this.vehicleRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.VEHICLE, { config: this.widgetConfig });
        this.returnLinkService = returnLinkService;
        this.rmbHelper = rmbHelper;
    }
    /**
     * @inheritDoc
     * @see IContainerInjection
     */
    static create(definition, widgetConfig, state, eventContext, container) {
        return new this(definition, widgetConfig, state, eventContext, container.get("ractive_wrapper"), container.get("plugin.provider.form_handler"), container.get("return_link"), container.get("factory.repository"), container.get("rmb_helper"));
    }
    /**
     * @inheritDoc
     */
    getTemplate() {
        return this.widgetConfig.getTemplate(TemplateTypes_1.TemplateTypes.SELECT_VEHICLE).getTemplate();
    }
    /**
     * @inheritDoc
     */
    initialize() {
        return super.initialize().then(() => {
            this.state.setIsAustraliaDistribution(this.rmbHelper.isAustraliaDistribution());
            if (!this.state.getVehicle()) {
                this.state.setVehicle(this.state.getVehicles().get(0));
            }
        });
    }
    /**
     * @inheritDoc
     */
    render() {
        const result = super.render();
        this.renderer.set("onImageError", this.onImageError.bind(this));
        this.renderer.set("selectVehicle", this.onVehicleSelect.bind(this));
        return result;
    }
    /**
     * @inheritDoc
     */
    submit(carIndex) {
        const chosenVehicle = this.state.getVehicles().getArray()[carIndex];
        const valuation = this.state.getValuation() || new Valuation_1.default();
        valuation.setVehicle(chosenVehicle);
        let promise;
        if (valuation.getToken()) {
            promise = this.valuationRepo.update(valuation)
                .then((updatedValuation) => {
                this.eventContext.emit(InchcapeSelectorEvents_1.InchcapeSelectorEvents.UPDATE_VALUATION, updatedValuation);
                return updatedValuation;
            });
        }
        else {
            valuation.setSource(this.widgetConfig.getSourceDealerId());
            valuation.setSourceUrl(this.widgetConfig.getSourceUrl());
            promise = this.valuationRepo.create(valuation)
                .then((updatedValuation) => {
                this.eventContext.emit(InchcapeSelectorEvents_1.InchcapeSelectorEvents.CREATE_VALUATION, updatedValuation);
                return updatedValuation;
            });
        }
        return promise.then((updatedValuation) => {
            let returnLink = this.returnLinkService.generateReturnLink(updatedValuation.getToken());
            console.log('To return use this link ', returnLink);
            updatedValuation.setReturnLink(returnLink);
            this.state.setValuation(updatedValuation);
            this.state.setVehicle(chosenVehicle);
            this.eventContext.emit(StepEvents_1.StepEvents.STEP_FINISHED);
        })
            .catch((error) => {
            this.eventContext.emit(WidgetEvents_1.WidgetEvents.INTERNAL_ERROR, error);
        });
    }
    onImageError(event) {
        const carImage = event === null || event === void 0 ? void 0 : event.node;
        if (carImage) {
            carImage.src = configs_1.configs.externalAssets.imageNotFound;
            carImage.onerror = null;
        }
    }
    onVehicleSelect(carIndex) {
        return this.submit(carIndex);
    }
}
exports.default = SelectVehicleStep;
exports.SelectVehicleStepDefinition = new WidgetFormStepPluginDefinition_1.default({
    id: StepTypes_1.StepTypes.SELECT_VEHICLE,
    form_id: SelectVehicleForm_1.SelectVehicleFormDefinition.getId(),
    class: SelectVehicleStep,
    priority: 3800
});
